import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { useAuthStore } from "./stores/auth";
import { useThemeStore } from "./stores/theme";
import { usePreferencesStore } from "./stores/preferences";
import "./styles/main.css";
import "vue-sonner/style.css";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

// La sesión debe restaurarse antes de registrar el router. `app.use(router)`
// inicia la navegación actual y el guard necesita conocer al usuario para no
// redirigir una recarga de una ruta protegida a `/login`.
useThemeStore(pinia).initialize();
usePreferencesStore(pinia).initialize();
await useAuthStore(pinia).initialize();

app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1 },
      mutations: { retry: 0 },
    },
  },
});
app.use(router);

// Evita montar la vista mientras la ruta inicial aún está resolviéndose.
await router.isReady();

app.mount("#app");
